import { z } from 'zod';
import { MetaSchema } from './create-chat.js';

/**
 * `GET /api/v1/workstreams/plan` contract (ADR-0071 §4/§7, D15-09) — the
 * tenant's plan with its **AUD figures**, for the Owner's Plan & billing page.
 * Owner only: the subscription and overage rate are commercial terms, so no
 * other endpoint carries them (the report's `plan` block is allowance only).
 * `plan` is absent when the tenant has none — never a default number.
 * `data` is strict (the BFF authors it); the envelope is loose (ADR-0024 §11).
 */
const DecimalSchema = z.string().regex(/^\d+(\.\d+)?$/);

export const PlanDataSchema = z.strictObject({
  plan: z
    .strictObject({
      name: z.string(),
      /** AUD per month, decimal string. */
      subscriptionAud: DecimalSchema,
      includedCredits: DecimalSchema,
      /** AUD per credit beyond the allowance, decimal string. */
      overageAudPerCredit: DecimalSchema,
      /** `true` → the UI says "Illustrative figures". */
      illustrative: z.boolean(),
    })
    .optional(),
});
export type PlanData = z.infer<typeof PlanDataSchema>;

export const PlanResponseSchema = z.looseObject({ data: PlanDataSchema, meta: MetaSchema });
export type PlanResponse = z.infer<typeof PlanResponseSchema>;
